import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { routesDef } from '../../config/routes'
import { Logout } from '../../components/Logout'
import { ListGroup } from 'react-bootstrap'
import { Icon, IconValueBlock, LoadingContent } from '@ztechapps/webui.util'
import { useHistory, useUser } from '@ztechapps/common.hook'
import { getWindow } from '@ztechapps/common.utils'
import { useMounted } from '../../hooks/useMounted'

const isActiveSelector = (path) => {
  //if (!Utils.hasWindow()) return false
  const win = getWindow()

  if (win?.location?.pathname?.includes?.(path)) {
    return true
  }
  return false
}

export const AccountContainer = ({ children }) => {
  const { loggedIn, loading } = useUser()
  const mounted = useMounted()
  const history = useHistory()
  const { pathname, search } = useLocation()

  // Replace, not push: Back from the login page must not return to this blocked page
  useEffect(() => {
    if (mounted && !loading && !loggedIn) {
      history.push(routesDef.LoginPage.altPath({ redirect_url: pathname + search }), { replace: true })
    }
  }, [mounted, loading, loggedIn, history, pathname, search])

  // Loading until mounted, so the server render and the hydration render match;
  // a signed-out visitor stays on the loader while the redirect is pending
  if (!mounted || loading || !loggedIn) return <LoadingContent />

  return (
    <section className="mb-5">
      <div className="container">
        <div className="row">
          <aside className="col-md-3">
            <ListGroup className="mb-3">
              <AccountMenuItem icon="list-alt" path={routesDef.AccountOverview.path} title="Account overview" />
              <AccountMenuItem icon="shopping-cart" path={routesDef.CartPage.path} title="My Cart" />
              <AccountMenuItem icon="file-invoice-dollar" path={routesDef.AccountOrders.path} title="My Orders" />
              <AccountMenuItem icon="comments" path={routesDef.AccountMessages.path} title="Messages" />
              <AccountMenuItem icon="heart" path={routesDef.AccountBoardsPage.path} title="My Favorites" />
              <AccountMenuItem icon="cogs" path={routesDef.AccountSettings.path} title="Settings" />

              <Logout className="list-group-item list-group-item-action">
                <Icon name="sign-out-alt" /> <span className="ms-2">Log out</span>
              </Logout>
            </ListGroup>
          </aside>

          <main className="col-md-9">{children}</main>
        </div>
      </div>
    </section>
  )
}

export const AccountMenuItem = ({ path, title, icon = 'trash' }) => {
  const history = useHistory()
  return (
    <ListGroup.Item active={isActiveSelector(path)} action onClick={() => history.push(path)}>
      <IconValueBlock icon={icon}>{title}</IconValueBlock>
    </ListGroup.Item>
  )
}
